import React from "react";
import { ButtonToolbar, Button } from "react-bootstrap";
import Moment from "react-moment";

import SeminarRegistrationsService from "../utils/SeminarRegistrationsService";
import Alert from 'react-s-alert';
import { confirmAlert } from 'react-confirm-alert';

class RegistrationActions {
  constructor(deal, handleDealUpdated) {
    this.deal = deal
    this.handleDealUpdated = handleDealUpdated
  }

  handleDealUpdate = (response) => {
    if (this.handleDealUpdated) this.handleDealUpdated(response)
  }

  registrationMarkAttendeeConfirmed = async (note) => {
    SeminarRegistrationsService.takeAction('mark_attendee_confirmed', this.deal.id, { note: note }).then((response) => {
      Alert.success('Confirmed attendee')
      this.handleDealUpdate(response)
    })
  }

  registrationMarkAttendeeNotConfirmed = async (note) => {
    SeminarRegistrationsService.takeAction('mark_attendee_not_confirmed', this.deal.id, { note: note }).then((response) => {
      Alert.success('Confirmed attendee')
      this.handleDealUpdate(response)
    })
  }

  registrationMarkSeminarAttended = async (note) => {
    SeminarRegistrationsService.takeAction('mark_seminar_attended', this.deal.id, { note: note })
      .then(response => {
        Alert.success('Attended seminar')
        this.handleDealUpdate(response)
      });
  }

  registrationMarkSeminarNotAttended = async (note) => {
    SeminarRegistrationsService.takeAction('mark_seminar_not_attended', this.deal.id, { note: note })
      .then(response => {
        Alert.success('Did not attend seminar')
        this.handleDealUpdate(response)
      });
  }
  registrationMarkRegistrationCancelled = async (note) => {
    SeminarRegistrationsService.takeAction('mark_cancelled', this.deal.id, { note: note })
      .then(response => {
        Alert.success('Cancelled')
        this.handleDealUpdate(response)
      });
  }

  registrationConfirmReschedule = (seminar) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className='confirmation-alert'>
            <h1>Reschedule to {seminar.location}?</h1>
            <p>Are you sure you want to reschedule this to</p>
            <h3>{seminar.location}, {seminar.address}</h3>
            <p><Moment format="MMM Do YYYY hh:mma">{seminar.at}</Moment></p>
            <ButtonToolbar>
              <Button bsStyle="default" bsSize="small" onClick={onClose}>No thanks!</Button>
              <Button className='pull-right' bsStyle="info" bsSize="small" onClick={() => {
                SeminarRegistrationsService.takeAction('reschedule', this.deal.id, { seminar_id: seminar.id })
                  .then(response => {
                    Alert.success('Rescheduled')
                    this.handleDealUpdate(response)
                  });
                onClose()
              }}>Reschedule it!</Button>
            </ButtonToolbar>
          </div>
        )
      }
    })
  }
}
export default RegistrationActions